import { LoaderFunction, redirect, useLoaderData, useNavigate } from "react-router-dom";

import { useTranslation } from "@/core/i18n";

import { getRepeatCashTransactions, getUser } from "api/methods";
import ChevronLeft from "atoms/icon/icons/chevron_left.svg";
import TopNav from "molecules/navbars/TopNav";
import { queryClient } from "pages/Root";
import { waitObj } from "toolbox/Promise";

import { RepeatCashActivityDetailsCard } from "./RepeatCashActivityDetailsCard";

const load = async (transactionId: string) => {
  const repeatCashTransactions = queryClient.fetchQuery({ ...getRepeatCashTransactions.keyed() });
  const user = queryClient.fetchQuery({ ...getUser.keyed() });
  const data = await waitObj({
    repeatCashTransactions,
    user,
  });
  const transactions = data.repeatCashTransactions?.transactions ?? [];
  const transaction = transactions.find((i) => i.id === transactionId);

  return { transaction, user: data.user };
};

type LoaderData = Awaited<ReturnType<typeof load>>;
export const repeatCashActivityDetailsLoader: LoaderFunction = async ({
  params: { transactionId },
}) => {
  if (!transactionId) return redirect("..");
  return await load(transactionId);
};

export const RepeatCashActivityDetailsPage = () => {
  const { t } = useTranslation();
  const { transaction, user } = useLoaderData() as LoaderData;
  const navigate = useNavigate();

  let headerLabel = t("repeatCashActivityDetailsPage.deductionDetailsHeader");
  if (transaction?.transactionType == "CashAdded") {
    headerLabel = t("repeatCashActivityDetailsPage.additionDetailsHeader");
  } else if (transaction?.transactionType == "CashExpired") {
    headerLabel = t("repeatCashActivityDetailsPage.expiredDetailsHeader");
  }

  return (
    <div className="relative h-full bg-one">
      <TopNav
        startIconSVG={ChevronLeft}
        showHeaderItems={false}
        onStartIconClick={() => navigate(-1)}
      >
        <div className="flex justify-center text-sub2">{headerLabel}</div>
      </TopNav>
      <div className="p-5">
        <RepeatCashActivityDetailsCard
          transaction={transaction}
          fallbackLocationName={user.platformLocation?.name}
        />
      </div>
    </div>
  );
};
